
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

interface MealCompositionFormData {
  name: string;
  recipeIds: string[];
}

interface MealCompositionFormFieldsProps {
  register: UseFormRegister<MealCompositionFormData>;
  errors: FieldErrors<MealCompositionFormData>;
}

const MealCompositionFormFields: React.FC<MealCompositionFormFieldsProps> = ({
  register,
  errors
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="name">Composition Name</Label>
      <Input
        id="name"
        placeholder="e.g., Sunday Family Dinner, Quick Weeknight Meals"
        {...register('name', { 
          required: 'Composition name is required',
          minLength: { value: 2, message: 'Name must be at least 2 characters' }
        })}
      />
      {errors.name && (
        <p className="text-sm text-destructive">{errors.name.message}</p>
      )}
    </div>
  );
};

export default MealCompositionFormFields;
